import React, { Component } from "react";
import _ from "lodash";
import { Table } from "semantic-ui-react";
import getPersonName from "../common/Name";

class Ofac extends Component {
  getName = (params) => {
    const node = params.node;
    return getPersonName(
      _.get(node, "first_Name[0]._", ""),
      _.get(node, "middle_Name[0]._", ""),
      _.get(node, "first_Name[0]._", ""),
      this.props
    );
  };

  render() {
    const { node } = this.props;

    const address1 = _.get(node, "addresses[0].address[0].address1[0]._", "");
    const address2 = _.get(node, "addresses[0].address[0].address2[0]._", "");
    const address3 = _.get(node, "addresses[0].address[0].address3[0]._", "");
    const aliaseRows = [];
    _.forEach(_.get(node, "akas[0].aka"), (aka, index) => {
      aliaseRows.push(
        <Table.Row key={`ofac_row_${index}`}>
          <Table.Cell>{`${_.get(aka, "first_Name[0]._", "")} ${_.get(
            aka,
            "last_Name[0]._",
            ""
          )}`}</Table.Cell>
        </Table.Row>
      );
    });

    return (
      <Table
        key={`InstantCriminal_Table_${this.props.index}`}
        className={`sub-table`}
      >
        <Table.Body>
          <Table.Row>
            <Table.Cell className={"sub-table-cell text-bold"}>
              Name:
            </Table.Cell>
            <Table.Cell className={"sub-table-cell"}>
              {this.getName({
                node: this.props.node,
                handleNewSearchClick: this.props.handleNewSearchClick,
              })}
            </Table.Cell>
            <Table.Cell className={"sub-table-cell text-bold"}>
              Addresses:
            </Table.Cell>
            <Table.Cell className={"sub-table-cell"}>
              {/* {address1 !== "" ? (
                <ul>
                  <li>
                    {_.get(node, "addresses[0].address[0].address1[0]._", "")}
                  </li>
                  {address2 !== "" ? <li>{address2}</li> : null}
                  {address3 !== "" ? <li>{address3}</li> : null}
                </ul>
              ) : null} */}
              {address1}
              {address2 !== "" ? (
                <span>
                  <br />
                  {address2}
                </span>
              ) : null}
              {address3 !== "" ? (
                <span>
                  <br />
                  {address3}
                </span>
              ) : null}
            </Table.Cell>
            <Table.Cell className={"sub-table-cell text-bold"}>
              Program:
            </Table.Cell>
            <Table.Cell className={"sub-table-cell"}>
              {_.get(node, "program[0]._", "")}
            </Table.Cell>
          </Table.Row>
          <Table.Row className={"table-no-border"}>
            <Table.Cell className={"sub-table-cell text-bold"}>
              Aliases:
            </Table.Cell>
            <Table.Cell className={"sub-table-cell"}>
              <Table className={"table-no-border"}>
                <Table.Body>{aliaseRows}</Table.Body>
              </Table>
            </Table.Cell>
            <Table.Cell />
            <Table.Cell />
            <Table.Cell className={"sub-table-cell text-bold"}>
              SDN Category:
            </Table.Cell>
            <Table.Cell className={"sub-table-cell"}>
              {_.get(node, "SDN_Type[0]._", "")}
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }
}

export default Ofac;



// WEBPACK FOOTER //
// ./src/components/searchresults/Ofac.js